import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/styles.css";
import "../../styles/layout.css";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import VisibilityIcon from "@mui/icons-material/Visibility";

import AppraisalViewController from "../../redux/actions/AppraisalAction";

import AppraisalReviewFormModal from "./AddAppraisalReview";

const AppraisalReviewList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editCycle, setEditCycle] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  const { getAppraisalReview, deleteAppraisalCycle, updateAppraisalCycle } =
    AppraisalViewController();
  const { appraisal_review } = useSelector((state) => state.apprisalcycle);

  useEffect(() => {
    dispatch(getAppraisalReview());
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deleteAppraisalCycle(id));

  const handleEdit = (cycle) => {
    setEditCycle(cycle);
    setShowModal(true);
  };

  const handleView = (cycle) => {
    setSelectedCycle(cycle);
    setViewModalOpen(true);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left"
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80
    },
    {
      headerName: "EMP Id",
      field: "employee_id",
      flex: 1
    },
    {
      headerName: "Employee",
      field: "employee_name",
      flex: 1
    },
    {
      headerName: "Appraisal Period",
      field: "appraisal_period",
      flex: 1
    },
    {
      headerName: "Rating",
      field: "rating",
      flex: 1
    },
    {
      headerName: "Review Date",
      field: "review_date",
      flex: 0.8
    },

    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          {/* <Tooltip title="View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      )
    }
  ];

  return (
    <div>
      {/* Top action bar */}
      <div
        className="d-flex flex-wrap mb-3 gap-2"
        style={{ justifyContent: "space-between" }}
      >
        <div className="mt-2">
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={() => {
              setEditCycle(null);
              setShowModal(true);
            }}
            sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",
              fontSize: "0.875rem"
            }}
          >
            Add Appraisal Review
          </Button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <ExportButton
            gridRef={gridRef}
            fileName="AppraisalCycles.xlsx"
            exportColumns={[
              "employee_name",
              "cycle_start",
              "cycle_end",
              "old_salary",
              "hike_percentage",
              "new_salary",
              "effective_from",
              "average_rating",
              "status"
            ]}
            disabled={selectedRows.length === 0}
            size="medium"
          />
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>

      {/* Header */}
      {/* <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Appraisal Review List</h3>
          </Col>
        </Row>
      </div> */}

      {/* Table */}
      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={appraisal_review}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      {/* Modals */}
      <AppraisalReviewFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editCycle}
      />
      {/* <AppraisalViewModal
        show={viewModalOpen}
        handleClose={() => setViewModalOpen(false)}
        appraisalCycle={selectedCycle}
      /> */}
    </div>
  );
};

export default AppraisalReviewList;
